import {atom} from "jotai";

export const scheduleEventTypeAtom = atom([ ]);
export const scheduleStatusTypeAtom = atom([ ]);
export const installersAtom = atom([ ]);
export const eventsAtom = atom([ ]);
export const zonesAtom = atom([ ]);

export const installerTypeClassAtom = atom([
    {
        name: "Install",
        class: "bg-installer-install"
    },
    {
        name: "ONT Lead",
        class: "bg-installer-ont-lead"
    },
    {
        name: "Drop",
        class: "bg-installer-drop"
    },
    {
        name: "Lead Drop",
        class: "bg-installer-lead-drop"
    },
    {
        name: "Drop Contractor",
        class: "bg-installer-drop-contractor"
    },
    {
        name: "Install Contractor",
        class: "bg-installer-install-contractor"
    },

    {
        name: "Consult Contractor",
        class: "bg-installer-consult-contractor"
    },
    {
        name: "Hybrid Service",
        class: "bg-installer-hybrid"
    },
    {
        name: "Senior Support",
        class: "bg-installer-senior"
    },
    {
        name: "Repair",
        class: "bg-installer-repair"
    },
    {
        name: "Aerial/Field",
        class: "bg-installer-aerial-field"
    },
    {
        name: "Field",
        class: "bg-installer-field"
    },
    {
        name: "Field Restoration",
        class: "bg-installer-field-restoration"
    },
    {
        name: "Region",
        class: "bg-installer-region"
    },
]);